<template lang="pug">	
	div.box
		div.box-header
			h3 General

		div.box-divider.m-a-0.p-a-0

		div.box-body
			div.row
				div.col-sm-6
					table.table.table-borderless
						tr
							td._500 Reference Id
							td {{ stockCheck.reference_id }}

						tr
							td._500 Start Time
							td {{ formattedDate(stockCheck.created_at) }}

						tr
							td._500 Status
							td
								span.label.hidden-print(
									:class="{'yellow': ! hasFinalized, 'success': hasFinalized}"
								)
									strong {{  completionStatus }}

						tr
							td._500 Completed Time
							td {{ hasFinalized ? formattedDate(stockCheck.completed_time) : 'N/A' }}

				div.col-sm-6
					table.table.table-form-input
						tr
							td._500 Outlet
							td {{ outlet.name }}

						tr
							td._500 General Notes
							td
								textarea.form-control(
									rows="3",
									v-if="canEdit",
									v-model="stockCheck.description"
								)
								span(v-else) {{ stockCheck.description }}

</template>

<script>
import { mapGetters, mapState } from 'vuex';
import stockCheckMixin from './stock-check-mixin';

export default {
    mixins: [stockCheckMixin],

    computed: {
        ...mapState('stockCheck', ['stockCheck']),

        ...mapGetters('stockCheck', [
            'outlet',
            'stockCheck',
            'completionStatus',
        ]),

        canUpdate() {
            return this.can(this.permission.SAVE_STOCK_CHECK);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-edit-info.vue